import * as React from 'react';
import {
  createTheme,
  IButtonProps,
  IIconProps,
  initializeIcons,
  SearchBox as MSSearchBox,
} from 'office-ui-fabric-react';
import { ThemeString } from '../../../context';
import './SearchBox.scss';

export interface SearchBoxProps {
  onSearch: (input: string) => any;
  onClear: () => any;
  onChange?: (input: string) => any;
  placeholder: string;
  inputValue?: string;
  isFilterBox?: boolean;
  theme?: ThemeString;
}

export class SearchBox extends React.Component<SearchBoxProps> {
  constructor(props: any) {
    super(props);
    initializeIcons();
  }

  public render() {
    const iconProps: Pick<
      IIconProps,
      Exclude<keyof IIconProps, 'className'>
    > = {};
    const clearProps: Pick<
      IButtonProps,
      Exclude<keyof IButtonProps, 'className'>
    > = { theme: this.createOfficeTheme() };

    if (this.props.isFilterBox) {
      iconProps.iconName = 'Filter';
    }

    const isLightTheme = this.props.theme === 'default';
    const isDarkTheme = this.props.theme === 'dark';
    const style: React.CSSProperties = {
      WebkitTextFillColor: isLightTheme
        ? '#252423'
        : isDarkTheme
        ? '#f3f2f1'
        : '#ffffff',
      WebkitBoxShadow: `0 0 0px 1000px ${
        isLightTheme ? '#ffffff' : isDarkTheme ? '#2d2c2c' : '$000000'
      } inset`,
    };

    return (
      <MSSearchBox
        className={'search-box'}
        placeholder={this.props.placeholder}
        value={this.props.inputValue}
        onSearch={this.props.onSearch}
        onClear={this.props.onClear}
        onChange={this.props.onChange}
        theme={this.createOfficeTheme()}
        iconProps={iconProps}
        maxLength={150}
        clearButtonProps={clearProps}
        style={style}
      />
    );
  }

  // We use Fluent UI search box, which does not have the themes we need.
  // So, we need to create them ourselves
  private createOfficeTheme() {
    const isLightTheme = this.props.theme === 'default';
    const isDarkTheme = this.props.theme === 'dark';
    return createTheme({
      palette: {
        themePrimary: '#6264a7',
        neutralPrimary: isLightTheme
          ? '#252423'
          : isDarkTheme
          ? '#f3f2f1'
          : '#ffffff',
        white: isLightTheme ? '#ffffff' : isDarkTheme ? '#2d2c2c' : '#000000',
        themeDark: '#4a4c7e',
      },
    });
  }
}
